import { useRef } from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const enabled = false

const RenderCount = (props) => {
  const { hide } = props
  const renderCount = useRef(0)
  return enabled && !hide ? (
    <Box sx={{ mb: 1 }}>
      <div className="dark:text-white">
        Rendered:{' '}
        <span className="dark:text-green-300 text-grey-900">
          {renderCount.current++} time(s)
        </span>
      </div>
    </Box>
  ) : null
}

RenderCount.propTypes = {
  hide: PropTypes.bool,
}

export default RenderCount
